<script>
import { mapGetters } from 'vuex';

export default {
  name: 'fisErrorModal',
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['errorObject']),
  },
  methods: {},
};
</script>
<template>
  <div id="errorModal" class="modal" tabindex="-1" >
    <div
      class="modal-dialog modal-xl modal-fullscreen-xl-down modal-dialog-scrollable "
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="title-globalModal" class="modal-title">{{ this.errorObject.title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <div id="body-globalModal" class="modal-body" style="white-space: pre-line">
          {{ this.errorObject.body }}
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  margin-top: 60px;
}
.st-ticketTime-mm {
  color: #1e8901;
}
.ot-ticketTime-mm {
  color: #7a1a1a;
}
.st-clockTime-mm {
  color: #1e8901;
}
.ot-clockTime-mm {
  color: #7a1a1a;
}
.npt-clockTime-mm {
  color: #5907b9;
}
.unbalanced-labor-mm {
  font-weight: bold;
  color: #dc3545;
}
</style>
